export default __webpack_public_path__ + "static/media/Flag_of_Serbia.07a11b31.svg";